<script>
  import ViewSession from "../ViewSession.svelte";
  import { _ } from "svelte-i18n";

  export let date;
  export let daySessions = [];
  let activeModal;

  function formatTime(session) {
    const durations = []
      .concat(session.warmUp)
      .concat(session.main)
      .concat(session.conclusion)
      .map((item) =>
        item !== undefined && item.duration !== undefined
          ? parseInt(item.duration)
          : undefined
      )
      .filter((item) => item !== undefined);

    const minutes = durations.reduce((sum, duration) => sum + duration, 0);

    const hours = Math.floor(minutes / 60).toFixed(0);
    const min = ("0" + (minutes % 60).toFixed(0)).slice(-2);

    return durations.length > 0 ? hours + ":" + min : "-";
  }
</script>

{#each daySessions as session, index}
  <div class="week-calendar__activity week-calendar__activity--is-done">
    <a
      class="week-calendar__activity-link week-calendar__activity-link--grow"
      on:click={(e) => {
        e.preventDefault();
        activeModal = index;
      }}
      href="/planer/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-07-15/CE11B6C8-5434-4D4F-B255-12557D85EFDF"
    >
      <div class="week-calendar__i-zone">
        <i class="icon icon--check week-calendar__icon" />
      </div>
      <time class="week-calendar__duration">{formatTime(session)}</time>
    </a>
    <a
      class="week-calendar__activity-link week-calendar__activity-link--super-grow"
      on:click={(e) => {
        e.preventDefault();
        activeModal = index;
      }}
      href="/planer/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-07-15/CE11B6C8-5434-4D4F-B255-12557D85EFDF"
    >
      <h2 class="week-calendar__name">{session.name}</h2>
    </a>
    <a
      class="week-calendar__activity-link"
      on:click={(e) => {
        e.preventDefault();
        activeModal = index;
      }}
      href="/planer/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-07-15/CE11B6C8-5434-4D4F-B255-12557D85EFDF#!load"
    >
      <div class="week-calendar__effort">
        <h3 class="week-calendar__label">{$_("plans.experiencedLoad")}.</h3>
        {session.experiencedLoad !== undefined ? session.experiencedLoad : "-"}
      </div>
    </a>
    <a
      class="week-calendar__activity-link"
      href="/planer/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-07-15/CE11B6C8-5434-4D4F-B255-12557D85EFDF#!form"
      on:click={(e) => {
        e.preventDefault();
        activeModal = index;
      }}
    >
      <div class="week-calendar__day-shape">
        <h3 class="week-calendar__label">{$_("plans.form")}</h3>
        {session.condition !== undefined ? session.condition : "-"}
      </div>
    </a>
  </div>
{/each}

{#if activeModal !== undefined}
  <div class="modal">
    <div class="modal__backdrop" />
    <div class="modal__wrapper">
      <div
        class="modal__content"
        style="animation: 0s ease 0s 1 normal none running none;"
      >
        <header class="modal__header">
          <button
            on:click={() => (activeModal = undefined)}
            type="button"
            class="modal__button-close"
          />
          <h1 class="h2">{daySessions[activeModal]?.name}</h1>
        </header>
        <ViewSession session={daySessions[activeModal]} />
      </div>
    </div>
  </div>
{/if}
